// Top progress bar loader (YouTube / nprogress style), matching the PLINEXT
// SpinLoader. A thin indeterminate bar fixed at the top of the viewport.
// Keeps the original Loader.show()/Loader.hide() API so every existing call
// site works unchanged; a reference counter keeps the bar visible while any
// number of concurrent operations are still loading.

const STYLE_ID = 'et-top-progress-style';
const BAR_ID = 'et-top-progress';
let activeCount = 0;

const injectStyles = () => {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    @keyframes et-top-progress-slide {
      0%   { left: -40%; right: 100%; }
      60%  { left: 100%; right: -35%; }
      100% { left: 100%; right: -35%; }
    }
    @keyframes et-top-progress-slide-2 {
      0%   { left: -100%; right: 100%; }
      60%  { left: -13%; right: 60%; }
      100% { left: 100%; right: -35%; }
    }
    .et-top-progress {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 3px;
      z-index: 99999;
      background: rgba(10, 31, 68, 0.08);
      overflow: hidden;
      pointer-events: none;
    }
    .et-top-progress::before,
    .et-top-progress::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      background: var(--button-bg, #1E90FF);
      will-change: left, right;
    }
    .et-top-progress::before {
      animation: et-top-progress-slide 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    }
    .et-top-progress::after {
      animation: et-top-progress-slide-2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
      animation-delay: 1.15s;
    }
  `;
  document.head.appendChild(style);
};

export default class Loader {

  static show = function () {
    activeCount += 1;
    injectStyles();
    if (!document.getElementById(BAR_ID)) {
      const bar = document.createElement('div');
      bar.id = BAR_ID;
      bar.className = 'et-top-progress';
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-label', 'Loading');
      document.body.appendChild(bar);
    }
  }

  static hide = function () {
    activeCount = Math.max(0, activeCount - 1);
    if (activeCount === 0) {
      document.querySelectorAll('#' + BAR_ID).forEach((el) => el.remove());
    }
  }
}
